import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import SvgIcon from '../SvgIcon/SvgIcon.js';

const ArrowButtons = _ref => {
  let {
    children,
    disabled,
    onScrollToNext,
    onScrollToPrev,
    nextButtonDisabled,
    nextButtonSvgIconType,
    prevButtonDisabled,
    prevButtonSvgIconType,
    testID
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(CarouselButton, {
      className: "embla__prev",
      disabled: prevButtonDisabled || disabled,
      onClick: onScrollToPrev,
      type: "button",
      "data-testid": `${testID}-prev-button`,
      children: prevButtonSvgIconType ? /*#__PURE__*/jsx(SvgIcon, {
        type: prevButtonSvgIconType
      }) : /*#__PURE__*/jsx(SvgIconPrevButtonStyled, {
        type: "caretRight"
      })
    }), /*#__PURE__*/jsx(CarouselButton, {
      className: "embla__next",
      disabled: nextButtonDisabled || disabled,
      onClick: onScrollToNext,
      type: "button",
      "data-testid": `${testID}-next-button`,
      children: /*#__PURE__*/jsx(SvgIcon, {
        type: nextButtonSvgIconType || 'caretRight'
      })
    }), children]
  });
};
const CarouselButton = styled.button`
  align-items: center;
  appearance: none;
  background: none;
  border: 0;
  cursor: pointer;
  height: 30px;
  justify-content: center;
  opacity: 0.6;
  outline: 0;
  padding: 0;
  position: absolute;
  top: 50%;
  touch-action: manipulation;
  transform: translateY(-50%);
  transition: opacity 0.2s;
  width: 30px;
  &:hover {
    cursor: pointer;
    opacity: 1;
  }
  &.embla__prev {
    left: 3px;
  }
  &.embla__next {
    right: 3px;
  }
  &:disabled {
    cursor: default;
    opacity: 0.3;
  }
`;
const SvgIconPrevButtonStyled = styled(SvgIcon)`
  margin-left: -3px;
  transform: rotate(180deg);
`;
ArrowButtons.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  disabled: PropTypes.bool,
  onScrollToNext: PropTypes.func.isRequired,
  onScrollToPrev: PropTypes.func.isRequired,
  nextButtonDisabled: PropTypes.bool,
  nextButtonSvgIconType: PropTypes.string,
  prevButtonDisabled: PropTypes.bool,
  prevButtonSvgIconType: PropTypes.string,
  testID: PropTypes.string
};
ArrowButtons.defaultProps = {
  children: null,
  disabled: false,
  nextButtonDisabled: false,
  nextButtonSvgIconType: '',
  prevButtonDisabled: false,
  prevButtonSvgIconType: '',
  testID: 'arrow'
};
var ArrowButtons$1 = ArrowButtons;

export { ArrowButtons$1 as default };
//# sourceMappingURL=ArrowButtons.js.map
